$(function() {
  $('div.fr-basic')
    .on('froalaEditor.initialized', function (e, editor) {
      editor.events.bindClick($('body'), 'a#get-text', function () {
        editor.html.set('');
        editor.events.focus();
      });
    })
});
